var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 98,
    viewBox: "0 0 118 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2699_19870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.471 0H2.5289C1.99105 0.00081234 1.47546 0.215679 1.09514 0.597506C0.714827 0.979332 0.500809 1.49697 0.5 2.03695V69.03C0.500809 69.57 0.714827 70.0877 1.09514 70.4695C1.47546 70.8513 1.99105 71.0662 2.5289 71.067H115.471C116.009 71.0662 116.525 70.8513 116.905 70.4695C117.285 70.0877 117.499 69.57 117.5 69.03V2.03695C117.499 1.49697 117.285 0.979332 116.905 0.597506C116.525 0.215679 116.009 0.00081234 115.471 0ZM117.049 69.03C117.049 69.4501 116.882 69.8528 116.586 70.1498C116.291 70.4468 115.889 70.6139 115.471 70.6143H2.5289C2.11052 70.6139 1.70941 70.4468 1.41357 70.1498C1.11774 69.8528 0.951332 69.4501 0.950867 69.03V2.03695C0.951331 1.61691 1.11774 1.21421 1.41357 0.917199C1.70941 0.620187 2.11052 0.453122 2.5289 0.452656H115.471C115.889 0.453122 116.291 0.620187 116.586 0.917199C116.882 1.21421 117.049 1.61691 117.049 2.03695V69.03Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.275 7.69531H0.725433V8.14797H117.275V7.69531Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5578 5.09238C5.18032 5.09238 5.68497 4.58573 5.68497 3.96074C5.68497 3.33575 5.18032 2.8291 4.5578 2.8291C3.93528 2.8291 3.43063 3.33575 3.43063 3.96074C3.43063 4.58573 3.93528 5.09238 4.5578 5.09238Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9393 5.09238C8.56182 5.09238 9.06647 4.58573 9.06647 3.96074C9.06647 3.33575 8.56182 2.8291 7.9393 2.8291C7.31678 2.8291 6.81213 3.33575 6.81213 3.96074C6.81213 4.58573 7.31678 5.09238 7.9393 5.09238Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3208 5.09238C11.9433 5.09238 12.448 4.58573 12.448 3.96074C12.448 3.33575 11.9433 2.8291 11.3208 2.8291C10.6983 2.8291 10.1937 3.33575 10.1937 3.96074C10.1937 4.58573 10.6983 5.09238 11.3208 5.09238Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2774 98.1131H31.7225C31.2145 98.1125 30.7274 97.9097 30.3682 97.549C30.009 97.1884 29.8069 96.6994 29.8063 96.1893V34.8545C29.8069 34.3444 30.009 33.8554 30.3682 33.4948C30.7274 33.1341 31.2145 32.9312 31.7225 32.9307H86.2774C86.7855 32.9312 87.2725 33.1341 87.6318 33.4948C87.991 33.8554 88.1931 34.3444 88.1936 34.8545V96.1893C88.1931 96.6994 87.991 97.1884 87.6318 97.549C87.2725 97.9097 86.7855 98.1125 86.2774 98.1131Z",
    fill: "#F4A807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0058 64.3901H42.9942Cnan nan nan nan 42.9942 64.3901L75.0058 58.7319V64.3901Cnan nan nan nan 75.0058 64.3901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0058 74.9146H42.9942Cnan nan nan nan 42.9942 74.9146L75.0058 69.2563V74.9146Cnan nan nan nan 75.0058 74.9146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0058 85.5518H42.9942Cnan nan nan nan 42.9942 85.5518L75.0058 79.8936V85.5518Cnan nan nan nan 75.0058 85.5518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1994 50.4712H52.8006Cnan nan nan nan 52.8006 50.4712L65.1994 44.813V50.4712Cnan nan nan nan 65.1994 50.4712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.439 16.0693H12.5607C11.2534 16.0693 10.1937 17.1333 10.1937 18.4458V18.4458C10.1937 19.7583 11.2534 20.8222 12.5607 20.8222H105.439C106.747 20.8222 107.806 19.7583 107.806 18.4458C107.806 17.1333 106.747 16.0693 105.439 16.0693Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2699_19870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 98,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyModule);
export default __webpack_public_path__ + "static/media/EmptyModule.0231f08772874fe170fb8d51f3115b1b.svg";
export { ForwardRef as ReactComponent };